var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 38.14 45.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b606d;}.cls-2{fill:#dce2ec;}.cls-3{fill:none;stroke:#4b606d;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Watch_01b",
    "data-name": "Watch_01b",
    viewBox: "0 0 38.14 45.37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 15.75,
    cy: 20.76,
    rx: 21.48,
    ry: 14.75,
    transform: "translate(-9.24 28.16) rotate(-69.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 22.39,
    cy: 24.6,
    rx: 21.48,
    ry: 14.75,
    transform: "translate(-8.53 36.87) rotate(-69.32)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "23.27 12.32 23.27 24.32 33.17 30.26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 38.14,
    height: 45.37,
    xlinkHref: "#Watch_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.aabab86feb1deb1909ccd21115ad5f88.svg";
export { ForwardRef as ReactComponent };